import React, { useState, useEffect } from "react";
import Booking from "./Booking";
import CheckIn from "./CheckIn";
import {Link } from "react-router-dom";
function BookingNow() {
  const [toggleState, setToggleState] = useState(1);
  const [showLogo, setShowLogo] = useState();
  const toggleTab = (index) => {
    setToggleState(index);
  };
  const [scrolled, setScrolled] = useState();
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  window.addEventListener('resize', handleResize)
  function handleResize() {
    setScreenWidth(window.innerWidth)
  }
  useEffect((_) => {
    if (screenWidth >1023) {
      const handleScroll = (_) => {
        if (window.pageYOffset > 450) {
          setScrolled(true);
          setShowLogo(true);
        } else {
          setScrolled(false);
          setShowLogo(false);
        }
      };
      window.addEventListener("scroll", handleScroll);
      return (_) => {
        window.removeEventListener("scroll", handleScroll);
      };
    }
  }, []);
  return (
    <div className={scrolled ? "bookingNow bookingScroll" : "bookingNow"}>
      <div className={showLogo ? "logo show" : "logo"}>
        <Link to="/">
          <img className="img-fluid" src="/images/logo.png" alt="" />
        </Link>
      </div>
      <div className="container">
        <div className="bookingTabs">
          <div
            className={toggleState === 1 ? "tabs activeTabs" : "tabs"}
            onClick={() => toggleTab(1)}
          >
            <img
              src={
                toggleState === 1
                  ? "/images/bookingactive.png"
                  : "/images/booking.png"
              }
              alt=""
            />
            <span>Đặt phòng</span>
          </div>
          <div
            className={toggleState === 2 ? "tabs activeTabs" : "tabs"}
            onClick={() => toggleTab(2)}
          >
            <img
              src={
                toggleState === 2
                  ? "/images/chkinactive.png"
                  : "/images/chkin.png"
              }
              alt=""
            />
            <span>Nhận phòng</span>
          </div>
        </div>
        <div className="BookingContent">
          <div
            className={
              toggleState === 1 ? "contentTabs activeContent" : "contentTabs"
            }
          >
            <form action="">
              <Booking />
            </form>
          </div>
          <div
            className={
              toggleState === 2 ? "contentTabs activeContent" : "contentTabs"
            }
          >
            <form action="">
              <CheckIn />
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
export default BookingNow;
